$(document).ready(function() {

    function openImage(e) {
        const image = $(this).data('src');
        const largeImage = `
        <div class="modal-image-container">
          <div class="close-button-modal-image">&#x2573;&#xfe0e;</div>
          <div class="inner-modal">
            <img src="${image}" alt="post-featured-image"/>
          </div>
        </div>
        `;

        $('.overlay-container').append(largeImage);
    };

    $(document).on('click', '.post-featured-image', openImage);
// -------------------------------------------------------------------------------------------------------------------- //
    function closeImage(e) {
            const innerModal = $('.inner-modal')
            if (!innerModal.is(e.target) && innerModal.has(e.target).length === 0) {
              $(this).remove();
            }
    };

    $(document).on('click','.modal-image-container', closeImage);
    $(document).on('click','.close-button-modal-image', function() {
        $('.modal-image-container').remove();
    });
    $(document).on('keydown', function(e) {
      if (e.keyCode == 27) {
        $('.modal-image-container').remove();
      }
    });

});